import React, {useContext} from 'react';
import {createConsumer} from '@rails/actioncable';
import config from '../config/applicationConfiguration';

const WebSocketContext = React.createContext(null);

const WebSocketProvider = ({children}) => {
    const actionCableUrl = config.environment.startsWith('LOCAL') ? 'ws://localhost:3001/cable' : `wss://${window.location.hostname}/cable`;

    const WebSocket = {};
    WebSocket.consumer = createConsumer(actionCableUrl);

    return <WebSocketContext.Provider value={WebSocket}>{children}</WebSocketContext.Provider>;
};

export {WebSocketContext, WebSocketProvider};

export const useWebSocket = () => useContext(WebSocketContext);


// WEBPACK FOOTER //
// ./src/context/websocket.js